import React from "react";

import Head from "next/head";
import { useRouter } from "next/router";

import HeroFullVideo, { BGIMAGE } from "../components/Hero/HeroFullVideo";
import RowList from "../components/Main/RowList";
import ImageCallout from "../components/Main/ImageCallout";
import PartnerLogos from "../components/Main/PartnerLogos";
import CtaBanner from "../components/Main/CtaBanner";
import Page from "../components/Page";
import Vignette from "../components/Main/Vignette";

export default function Documentary(props) {
  const router = useRouter();

  const isLiftTheMask = router.asPath.startsWith("/lift-the-mask-documentary");

  const {
    //Documentary intro fields connecting to HeroFullVideo
    documentary_still: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId,
    },
    documentary_video_src: introVideo,
    documentary_heading: introHeading,
    documentary_subheading: introParagraph,

    //Image callout middle fields "Hosting Campus screening?"
    //callout_about_image: ,
    callout_about_image_caption: aboutCaption,
    callout_about_heading: aboutHeading,
    callout_about_sub_heading: aboutSubheading,
    callout_about_paragraph: aboutParagraph,
    callout_about_link: {
      url: aboutUrl,
      title: aboutLinkTitle,
      target: aboutLinkTarget,
    },
    callout_about_column_order: aboutColOrder,
    intro_link_icon: aboutIcon,

    //image callout upper fields

    callout_upper_images: calloutImages,
    callout_upper_heading: calloutHeading,
    callout_upper_sub_heading: calloutSubheading,
    callout_upper_paragraph: calloutParagraph,
    callout_upper_link: { url: calloutUrl, title: calloutLinkTitle },
    callout_upper_sub_text: calloutSubText,
    callout_upper_column_order: colOrder,

    //CtaBanner Fields
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton },

    //documentary been field group (Logos section)
    documentary_been_logos: documentaryLogos,
    documentary_been_heading: documentaryHeading,
    documentary_been_paragraph: documentaryParagraph,

    //Vignette fields
    vignette_heading: vignetteHeading,
    vignette_link: vignetteLink,
    vignette_copy: vignetteCopy,
    vignette_video: vignetteVideos,

    // Callout Lower
    callout_lower_image: lowerImage,
    callout_lower_image_caption: lowerCaption,
    callout_lower_heading: lowerHeading,
    callout_lower_sub_heading: lowerSubheading,
    callout_lower_paragraph: lowerParagraph,
    callout_lower_link: lowerLink,
    callout_lower_column_order: lowerColOrder,
    intro_link_icon: lowerIcon,
  } = props.acf;

  return (
    <React.Fragment>
      <Head>
        {/* Polaris */}
        {isLiftTheMask && (
          <>
            <script
              dangerouslySetInnerHTML={{
                __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','GTM-5VRVLMZ');`,
              }}
            />
            <script
              dangerouslySetInnerHTML={{
                __html: `(function(){ var e = document.getElementsByTagName("script")[0]; var d = document.createElement("script"); d.src = "//insiderdata360online.com/service/platform.js?ran="+Math.random(); d.type = "text/javascript"; d.async = true; d.defer = true; e.parentNode.insertBefore(d,e); })();`,
              }}
            />
          </>
        )}
      </Head>
      <Page
        title={"Documentary"}
        body={calloutParagraph}
        heroTitle={introHeading}
        heroBody={introParagraph}
        bgVideo={introVideo}
        bgImage={introImage}
        height={900}
        width={1900}
        videoHeight={791}
        videoWidth={1500}
        slug={"/documentary"}
      >
        <main id="content">
          <div className="scholarship-list">
            <RowList
              title={aboutHeading}
              body={aboutParagraph}
              link={aboutUrl}
              target={aboutLinkTarget}
              button={aboutLinkTitle}
            />
          </div>
          {lowerImage && (
            <ImageCallout
              reversed
              title={lowerHeading}
              body={lowerParagraph}
              link={lowerLink.url}
              button={lowerLink.title}
              image={lowerImage.url}
            />
          )}
          {calloutImages && calloutHeading && (
            <ImageCallout
              array
              title={calloutHeading}
              body={calloutParagraph}
              link={calloutUrl}
              images={calloutImages}
            />
          )}
          {documentaryLogos && (
            <PartnerLogos
              documentary
              logos={documentaryLogos}
              logoHeading={documentaryHeading}
              logoParagraph={documentaryParagraph}
            />
          )}

          {vignetteHeading && (
            <Vignette
              className="-tw-mt-20 tw-pb-52 tw-px-20"
              heading={vignetteHeading}
              copy={vignetteCopy}
              videos={vignetteVideos}
              linkUrl={vignetteLink.url}
              linkText={vignetteLink.title}
              target={vignetteLink.title}
            />
          )}
        </main>

        <CtaBanner title={ctaHeading} link={ctaLink} button={ctaButton} />
      </Page>
      <style jsx>{`
        .scholarship-list {
          margin: 200px 0;
        }
      `}</style>
    </React.Fragment>
  );
}
